export default [
    {
        id: 1,
        name_ca: 'Acabat',
        name_es: 'Terminado',
        name_en: 'Finished',
        code_bde: 'U00'
    }, {
        id: 2,
        name_ca: 'En construcció: obra actualment en procés d\'execució (inclou els edificis en procés de rehabilitació)',
        name_es: 'En construcción: obra en marcha (incluye los edificios en proceso de rehabilitación)',
        name_en: 'Under construction: work in process (including buildings being renovated)',
        code_bde: 'U01',
    }, {
        id: 3,
        name_ca: 'En construcció: obra parada (inclou els edificis en procés de rehabilitació)',
        name_es: 'En construcción: obra parada (incluye los edificios en proceso de rehabilitación)',
        name_en: 'Under construction: work stopped (including buildings being renovated)',
        code_bde: 'U02'
    }, {
        id: 4,
        name_ca: 'Inmoble en projecte. L\'obra no ha començat',
        name_es: 'Inmueble en proyecto. La obra no ha empezado',
        name_en: 'Planned. The construction has not started.',
        code_bde: 'U03'
    }, {
        id: 5,
        name_ca: 'No aplicable',
        name_es: 'No aplicable',
        name_en: 'Not applicable',
        code_bde: 'ZZZ'
    }
]



// WEBPACK FOOTER //
// ./src/options/construction_statuses.js